import { CDN_URL } from "../Helpers";
import React from "react";

export default function OneStaff({ data }) {
  const photoUrl = data?.photo ? `${CDN_URL}${data.photo}` : "";
  const name = data?.fullName || "Staff Member";
  const position = data?.role || "Team Member";

  return (
    <div
      className="w-100 h-100"
      style={{
        minHeight: "340px",
      }}
    >
      <div
        className="bg-white w-100 h-100 d-flex flex-column align-items-center justify-content-center p-4"
        style={{
          borderRadius: "20px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
          transition: "all 0.3s ease",
          cursor: "default",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-5px)";
          e.currentTarget.style.boxShadow = "0 12px 30px rgba(0, 0, 0, 0.08)";
          e.currentTarget.style.borderColor = "#cbd5e1";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 4px 20px rgba(0, 0, 0, 0.05)";
          e.currentTarget.style.borderColor = "#e2e8f0";
        }}
      >
        {/* Image Container - Fixed size to prevent zooming/cropping issues */}
        <div
          className="mb-4 position-relative"
          style={{
            width: "90%",
            height: "240px",
            flexShrink: 0,
          }}
        >
          {photoUrl ? (
            <img
              src={photoUrl}
              alt={name}
              className="w-100 h-100"
              style={{
                objectFit: "cover",
                objectPosition: "center top",
                borderRadius: "16px",
                border: "1px solid #f1f5f9",
                backgroundColor: "#f8fafc",
              }}
            />
          ) : (
            <div
              className="w-100 h-100 d-flex align-items-center justify-content-center"
              style={{
                borderRadius: "16px",
                backgroundColor: "#f1f5f9",
                border: "1px solid #e2e8f0",
                color: "#94a3b8",
                fontSize: "3rem",
              }}
            >
              <span>👤</span>
            </div>
          )}
        </div>

        {/* Content */}
        <div className="text-start w-100">
          <h5
            className="mb-2 fw-bold"
            style={{
              fontSize: "1.15rem",
              color: "#1e293b",
              letterSpacing: "-0.02em",
            }}
          >
            {name}
          </h5>

          <div
            className="d-inline-block px-3 py-1 font-semi-bold"
            style={{
              backgroundColor: "#f1f5f9",
              color: "#1d2633",
              borderRadius: "5px",
              fontSize: "0.85rem",
              fontWeight: "500",
              letterSpacing: "0.02em",
              textTransform: "uppercase"
            }}
          >
            {position}
          </div>

           <div
              className="description text-start"
              style={{
                width: "100%",
                padding: "0",
                overflow: "hidden",
              }}
              dangerouslySetInnerHTML={{ __html: data.description }}
            ></div>
        </div>
      </div>
    </div>
  );
}